import React from 'react';

import { useIsLoggedOutProfileCreationEnabled, useTrackSubmitConfirmationPageview } from '../../hooks';

export const SubmitConfirmationTrackingLo: React.VFC<{ confirmationTrackingBaseData?: object }> = ({
  confirmationTrackingBaseData = {},
}) => {
  const isLoggedOutProfileCreationEnabled = useIsLoggedOutProfileCreationEnabled();
  const baseData = isLoggedOutProfileCreationEnabled ? { ...confirmationTrackingBaseData } : {};

  useTrackSubmitConfirmationPageview(baseData);

  return null;
};
